























































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { FullReferralsResponse, ReferralUser } from '@/views/chat/types'
import { cloneDeep } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import TableLayout from '@/views/chat/TableLayout.vue'
import UserMainInfo from 'piramis-base-components/src/components/UserMainInfo.vue'

@Component({
  components: {
    TableLayout,
    UserMainInfo,
  },
  data() {
    return {
      isMobile,
    }
  }
})
export default class Referrals extends Vue {
  gentime: string = ''

  chat_title: string = ''

  pagination = 10

  referrals: Array<ReferralUser & { indexPosition: number }> = []

  tableTemplate = 0

  loaded = false

  searchQuery = ''

  get searchResult(): Array<ReferralUser & { indexPosition: number }> {
    if (!this.searchQuery.length) {
      return this.referrals
    } else {
      return this.referrals
        .filter(user => {
          if (user.user_name) {
            if (user.user_name.toLowerCase().includes(this.searchQuery.trim().toLowerCase())) {
              return user
            }
          }
        })
        .sort((a, b) => b.referrals - a.referrals)
        .map((user, index) => {
          return { ...user, indexPosition: index + 1 }
        })
    }
  }

  getGenDate() {
    if (this.gentime) {
      return new Date(this.gentime).toLocaleDateString(this.$i18n.locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      })
    }
  }

  onClick(value: any): void {
    switch (value.key) {
      case '1':
        this.pagination = 10
        break
      case '2':
        this.pagination = 15
        break
      case '3':
        this.pagination = 20
        break
      case '4':
        this.pagination = 25
        break
      case '5':
        this.pagination = 30
        break
    }
    this.tableTemplate += 1
  }

  mounted(): void {
    this.loaded = true

    // setTimeout(() => {
    // const res = TEST
    this.$store.dispatch(this.$route.name === 'referrals' ? 'getChatReferralsList' : 'getChatActiveReferralsList', this.$route.params.id)
      .then((res: FullReferralsResponse) => {
        this.gentime = res.gentime
        this.chat_title = res.chat_title

        this.referrals = cloneDeep(res.users).sort((a, b) => b.referrals - a.referrals).map((user, index) => {
          return { ...user, indexPosition: index + 1 }
        }) as Array<ReferralUser & { indexPosition: number }>
      })
      .finally(() => {
        this.loaded = false
      })
    // }, 500)
  }
}
